<template>
  <div class="protocol-item-model">
    <div class="search-hd" style="padding-top: 0; height: 44px">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="!isDeriveProtocol">
          <el-button type="primary" icon="icon icon-add" @click="addModel">&ensp;{{ $t('Common.com_add') }}</el-button>
        </el-form-item>
        <el-form-item v-if="!isDeriveProtocol">
          <el-button icon="icon icon-shanchu" :disabled="!selectList.length" @click="batchDeleteModel">&ensp;{{ $t('Common.com_delete') }}</el-button>
        </el-form-item>
        <el-form-item v-if="!isDeriveProtocol">
          <el-button icon="icon icon-daoru" @click="importModel">&ensp;{{ $t('dms_protocol_item_model.kuai_su_dao_ru') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_protocol_item_model.wmxmcwmxdm')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group v-model="formSearch.tslClass" @change="changeTslClass()">
            <el-radio-button v-for="(item, index) in tslClassType" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_protocol_item_model.lei_xing')">
          <el-select size="small" clearable v-model="formSearch.tslType" :placeholder="$t('Common.com_please_select')">
            <el-option v-for="(item, i) in tslTypeList" :key="i" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_model.bu_jian')">
          <el-input v-model="formSearch.component"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_model.fen_lei')">
          <el-input v-model="formSearch.dataGroup"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_model.TCPdai_ma')">
          <el-input v-model="formSearch.tcpDataCode"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="table"
        type="checkbox"
        v-model="selectList"
        :data="tableList"
        tableCode="protocol_model_list"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['dbUnit', 'needTestTypes', 'showUnit', 'tcpDataUnit', 'action']"
        :filterArr="isDeriveProtocol ? ['action'] : []"
        height="100%"
      >
        <template v-slot:needTestTypes="scope">
          {{ getNeedTestTypes(scope.row.needTestTypes) || '-' }}
        </template>
        <!-- 存储单位 dbRatio dbUnit iot_tsl_data_unit -->
        <template v-slot:dbUnit="scope">
          {{ getStockUnit(scope.row) }}
        </template>
        <!-- 显示单位 showRatio showUnit iot_tsl_data_unit -->
        <template v-slot:showUnit="scope">
          {{ getShowUnit(scope.row) }}
        </template>
        <!-- 协议单位 tcpDataRatio tcpDataUnit iot_tsl_data_unit -->
        <template v-slot:tcpDataUnit="scope">
          {{ getProtocolUnit(scope.row) }}
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button v-if="!isDeriveProtocol" type="text" size="mini" @click="editModel(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button v-if="!isDeriveProtocol" type="text" size="mini" @click="deleteModel(scope.row)">{{ $t('Common.com_delete') }}</el-button>
            <el-button v-if="!isDeriveProtocol" type="text" size="mini" @click="copyModel(scope.row)">{{ $t('Common.com_copy') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <model-add-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()" :protocolCode="protocolCode"></model-add-dialog>
    <model-import-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getTableList()"
      :protocolCode="protocolCode"
      :productId="productId"
    ></model-import-dialog>
    <!--

    <model-publish-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getTableList()"
    ></model-publish-dialog> -->
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('dms_protocol_item_model.sybxyjg') }}</el-button>
      <el-button type="primary" @click="onStep">{{ $t('dms_protocol_item_model.xia_yi_buTopic') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTable from '@/components/customTable.vue';
import mixins from './mixins';
import modelAddDialog from './step_model_add_dialog';
import modelImportDialog from './step_model_import_dialog';

export default {
  mixins: [mixins],
  components: {
    modelAddDialog,
    customTable,
    modelImportDialog,
  },
  props: {
    // protocolCode: String,
    // protocolType: String,
    // productId: [String, Number]
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
  data() {
    return {
      tslTypeList: [],
      formSearch: {
        type: 0,
        protocolCode: '',
        tcpDataCode: '',
        tslVersion: '',
        tslClass: '',
        tslType: '',
        component: '',
        dataGroup: '',
        dbField: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 30,
        pageNum: 1,
      },
      selectList: [],
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},

      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      protocolCode: '',
      protocolType: '',
      tslClassType: [],
    };
  },
  mounted: function () {
    this.initData();
    this.formSearch.protocolCode = this.protocolCode;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDictionary('iot_tsl_class_type', (data) => {
      this.tslClassType = data.iot_tsl_class_type;
      this.changeTslClass(true);
    });
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    onStep: function () {
      this.$emit('step', { name: 'model' });
    },
    initData() {
      if (this.info && this.info.protocolCode) {
        this.protocolCode = this.info.protocolCode;
        this.protocolType = this.info.protocolType;
      }
    },
    changeTslClass: function (init) {
      if (init) {
        this.formSearch.tslClass = this.tslClassType[0].value;
        this.tslTypeList = this.tslClassType[0].children || [];
        this.onPageChange({ page: 1 });
        return;
      }
      this.tslClassType.forEach((item) => {
        if (this.formSearch.tslClass === item.value) {
          this.tslTypeList = item.children || [];
        }
      });
      this.onPageChange({ page: 1 });
    },
    // 快速导入
    importModel: function () {
      this.dialogModel1.title = this.$t('dms_protocol_item_model.kuai_su_dao_ru');
      this.dialogModel1.data = {};
      this.dialogVisible1 = true;
    },
    // 新增物模型
    addModel: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_protocol_item_model.xin_zeng_wu_mo_xing');
      this.dialogModel.data = {};
      this.dialogVisible = true;
    },
    // 编辑物模型
    editModel: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('dms_protocol_item_model.bian_ji_wu_mo_xing');
      this.dialogModel.data = {};
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 拷贝物模型
    copyModel: function (data) {
      this.dialogModel.type = 'copy';
      this.dialogModel.title = this.$t('dms_protocol_item_model.xin_zeng_wu_mo_xing');
      this.dialogModel.data = {};
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 删除物模型
    deleteModel: function (data) {
      const tips = this.$t('dms_protocol_item_model.nqdyscxzdwmxm');
      this.$showConfirm(tips)
        .then(() => {
          const reqData = {
            tslIds: data.tslId,
            pageNum: this.formSearch.pageNum,
            pageSize: this.formSearch.pageSize,
            protocolCode: this.info.protocolCode,
          };
          this.$postJSON(apis.TslDelete, reqData).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 批量删除物模型
    batchDeleteModel: function () {
      const tips = this.$t('dms_protocol_item_model.nqdyscxzdwmxm');
      const tslIds = this.selectList.map(t => t.tslId).join(',');
      this.$showConfirm(tips)
        .then(() => {
          const reqData = {
            tslIds,
            pageNum: this.formSearch.pageNum,
            pageSize: this.formSearch.pageSize,
            protocolCode: this.info.protocolCode,
          };
          this.$postJSON(apis.TslDelete, reqData).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 发布物模型
    publishModel: function () {
      this.dialogModel2.title = this.$t('dms_protocol_item_model.fa_bu_wu_mo_xing');
      this.dialogModel2.data = {};
      this.dialogModel2.data.protocolCode = this.protocolCode;
      this.dialogVisible2 = true;
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.TslPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      const tslClass = this.formSearch.tslClass;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.tslClass = tslClass;
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.protocol-item-model {
  display: flex;
  height: 100%;
  flex-direction: column;
  .el-radio-group {
    float: left;
  }
}
</style>
